export default "__VITE_PUBLIC_ASSET__124ac29c__"